<template>
  <div>
    <v-data-table
      :loading="loading"
      :headers="headers"
      :items="items"
      :items-per-page="10"
      :server-items-length="meta.total"
      :footer-props="footerProps"
      :options.sync="options"
      :sort-by="sortBy"
      sort-desc
    >
      <template v-slot:item.model="{ item }">
        <v-badge
          dot
          left
          inline
          :color="item.activity_last_hour ? 'primary' : 'red'"
        >
          <span class="pl-2">{{ item.model }}</span>
        </v-badge>
      </template>

      <template v-slot:item.apartment="{ item }">
        <span class="mr-2">{{ item.apartment.name }}</span>
        <v-icon small @click="$emit('show-apartment', item)">
          mdi-eye-outline
        </v-icon>
      </template>

      <template v-slot:item.action="{ item }">
        <div class="text-center">
          <v-list-item @click="$emit('show', item)">
            <v-list-item-title>
              <v-icon class="mr-1" small>mdi-eye</v-icon>
              {{ $t('ITEM.VIEW') }}
            </v-list-item-title>
          </v-list-item>
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import i18nRefreshData from '@/modules/_global/mixins/i18nRefreshData';

export default {
  name: 'SmartHomeDevicesList',

  mixins: [i18nRefreshData],

  props: {
    items: {
      type: Array,
      default: () => []
    },
    meta: {
      type: Object,
      default: () => ({
        total: 0
      })
    },
    filters: {
      type: Object,
      default: () => {}
    }
  },

  data: () => ({
    options: {},
    sortBy: 'id',
    footerProps: {
      showFirstLastPage: true,
      itemsPerPageOptions: [10, 50, 100]
    }
  }),

  computed: {
    ...mapState(['loading']),

    params() {
      const options = this.options;

      return {
        page: options.page,
        per_page: options.itemsPerPage,
        sort_by: options.sortBy[options.sortBy.length - 1],
        order_by: options.sortDesc[options.sortDesc.length - 1] ? 'desc' : 'asc'
      };
    },

    headers() {
      return [
        {
          text: this.$t('ITEM.ID'),
          sortable: true,
          value: 'id'
        },
        {
          text: this.$t('SMARTHOME_DEVICES.MODEL'),
          sortable: true,
          value: 'model'
        },
        {
          text: this.$t('APARTMENTS.ITEM'),
          sortable: true,
          value: 'apartment.name'
        },
        {
          text: this.$t('BUILDINGS.ITEM'),
          sortable: true,
          value: 'apartment.building.street'
        },
        {
          text: this.$t('SMARTHOME_DEVICES.APP_VERSION'),
          sortable: true,
          value: 'app_version'
        },
        {
          text: this.$t('ITEM.STATUS'),
          sortable: true,
          value: 'status.name'
        },
        {
          text: this.$t('DATA_TABLE.ACTIONS'),
          value: 'action',
          sortable: false,
          align: 'center'
        }
      ];
    }
  },

  watch: {
    options: {
      handler() {
        this.refreshData();
      },
      deep: true
    },
    filters: {
      handler() {
        this.options.page = 1;
        this.refreshData();
      },
      deep: true
    }
  },

  methods: {
    refreshData() {
      this.$emit('refresh', {
        params: Object.assign({}, this.filters, this.params)
      });
    }
  }
};
</script>
